import {
    SAVE_HOME_IMAGE,
    RESET_HOME_IMAGE
} from './actions';

export const initialState = {
    homeImage: '',
};

const homeImageReducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_HOME_IMAGE:
            return {
                ...state,
                homeImage: action.homeImage
            }
        case RESET_HOME_IMAGE:
            return {
                ...state,
                ...initialState
            }
        default: return state
    }
}

export default homeImageReducer;